// Copyright (c) 2017 Deere & Company

/* eslint-disable complexity, max-params */

export const buildTransferPayload = (facets, exportToExcel, language, layout = '', listId = '') => ({
    accounts: facets.dealerAccountsFacet.selectedDealers.map(dealer => dealer.account),
    export: exportToExcel,
    language,
    layout,
    listId,
    requestedDateFrom: facets.requestedDateRange.dateRange.from,
    requestedDateTo: facets.requestedDateRange.dateRange.to
});

/* eslint-enable complexity, max-params */



// WEBPACK FOOTER //
// ./src/product/shared/services/build-transfer-payload.js